import axios from 'axios'
import type { InsuranceParamsTravelDto } from 'BrokerTsLib/src/dtos'
import { useMutation } from '@tanstack/react-query'
import { baseUrl } from '.'

const wizardApiUrl = import.meta.env.VITE_WIZARD_TRAVEL_API
const url = `${baseUrl}/${wizardApiUrl}`

export const useAddVariant = (paramsId: string) =>
  useMutation({ mutationFn: (data: InsuranceParamsTravelDto) =>
    axios.post(`${url}/AddVariant?paramsId=${paramsId}`, data) })
